import { cardAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(cardAnatomy.keys);

const baseStyle = definePartsStyle({
  // define the part you're going to style
  container: {
    // backgroundColor: "#e7e7e7",
    padding: "0px",
  },
  header: {
    marginTop: "5px",
    marginBottom: "0",
  },
  body: {
    paddingTop: "0px",
    // paddingLeft: "0px",
    // paddingRight: "0px",
    marginLeft: "0px",
  },
  footer: {
    paddingTop: "2px",
  },
});

const sizes = {
  md: definePartsStyle({
    container: {
      borderRadius: "0px",
      border: "1px solid #D1D5DB",
    },
  }),
};

const ChakraUICardStyling = defineMultiStyleConfig({ baseStyle, sizes });

export default ChakraUICardStyling;
